import { toast } from 'react-toastify';

export const calculateTotalWeight = (booking: {
  maleWeight?: number | string;
  male?: number;
  femaleWeight?: number | string;
  female?: number;
  childWeight?: number | string;
  child?: number;
}) => {
  return (
    (Number(booking?.maleWeight) || 0) * (Number(booking?.male) || 0) +
    (Number(booking?.femaleWeight) || 0) * (Number(booking?.female) || 0) +
    (Number(booking?.childWeight) || 0) * (Number(booking?.child) || 0)
  );
};

export const calculatePaxPercentage = (
  totalPax: number,
  totalAllocatedPax: number,
): number => {
  if (totalPax === 0) return 0;
  return ((totalPax - totalAllocatedPax) / totalPax) * 100;
};

export const showOrReplaceToast = (
  id: string,
  message: string,
  type: 'success' | 'error' | 'info' | 'warning',
) => {
  if (toast.isActive(id)) {
    toast.update(id, {
      render: message,
      type,
      autoClose: 3000,
    });
  } else {
    toast(message, {
      toastId: id,
      type,
      autoClose: 3000,
    });
  }
};

export const getStatusColorClass = (status: string): string => {
  const normalizedStatus = status?.toLowerCase()?.replace(/\s+/g, '') ?? '';

  if (normalizedStatus.includes('cxl') || normalizedStatus.includes('cancel')) {
    return 'text-text-textRed';
  //TODO: need to ask from jitendra
  }
  if (normalizedStatus.includes('confirmed')) {
    return 'text-[var(--confirmed)]';
  }

  if (
    normalizedStatus.includes('paid') ||
    normalizedStatus.includes('held') ||
    normalizedStatus.includes('ftl') ||
    normalizedStatus.includes('tentative') ||
    normalizedStatus.includes('standby') ||
    normalizedStatus.includes('voucher') ||
    normalizedStatus.includes('outstanding') ||
    normalizedStatus.includes('enquiry')
  ) {
    return 'text-backgroundColor-buttonCommonColor';
  }
  if (normalizedStatus.includes('booked')) {
    return 'text-text-textGreen';
  }
  if (normalizedStatus.includes('confirmationrequest')) {
    return 'text-[var(--confirmationrequest)]';
  }

  return 'text-text-primary';
};

export const getLocationNameFromOwnerId = (ownerId: number): string => {
  switch (ownerId) {
    case 1:
      return 'Hot Air Balloon Cairns & Port Douglas';
    case 9:
      return 'Hot Air Balloon Brisbane & Gold Coast';
    default:
      return 'Unknown Location';
  }
};